import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../config.service';
import { SecurityService } from '../security.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  fileToUpload: File = null;
  defaultImage: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAIAAABMXPacAAACoklEQVR4nO3dS0sjQRRA4apYxrgxAROCNhhRcOPj//8IdwquNKGlG0x8YOMjCEnPIkMQZzeOcwTPt0o1zaXg0HebeHp6GsRp0Bf46QwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwAwAMwDMADADwBJ9gRBCeHp6Go/He3t7IYS6rvM8f3x8TCllWdZut4uiuLu7azabg8FgfX0dGfh1+AA3NzcPDw+rq6uL4/39fYzx6Ojo9fV1OBymlJ6fnw8PD6uqKstyf3///w/8UvwKWltb293dXR43Nzd3dnYajUar1VpZWWk0ft8wxhhjXL52e3s7HA5DCKPRaDKZfH4ghf8COp3OdDr98HA2m41Go62trVarlVI6OzuLMS5WykK3262q6urqKoTQ6/U+P5DCfwF/mk6nl5eX3W630+lMJpNms3lycnJwcHB9fT2fz5ev9fv9qqr6/f6/Goj4dgHe3t7yPB8MBu12O4Qwn8/rug4hxBgXPxbqui6KIsuyoijeP//rgRR+BX0wHo9fXl4uLi4Wx+Pj4zzPz8/PU0rb29vLDV6W5cbGRq/Xm81mZVlmWfbJgZTon/iwvt0K+mkMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMADMAzAAwA8AMAPsFeCT73vNxXKUAAAAASUVORK5CYII='
  imageUrl: string = null;
  errorMessage: string = null;
  
  constructor(private http: HttpClient,
    private config: ConfigService,
    private securityService: SecurityService,
    public router: Router
    ) {
    this.imageUrl = this.config.host + '/public/partner-logo?partnerId='+localStorage.getItem('partnerId')
  }

  ngOnInit() {
  }

  handleFileInput(event) {
    this.errorMessage = null
    this.fileToUpload = event.target.files.item(0);
    this.previewImage();
    this.uploadImage(event);
  }

  previewImage() {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    };
  }

  removeImage() {
    this.http.delete(this.config.host + '/api/logo-partner?partnerId='+localStorage.getItem('partnerId')).subscribe(
      (response) => this.imageUrl = this.defaultImage,
      (error) => error.status === 401 ? this.securityService.refreshToken().then(() => this.removeImage()) : console.log(error)
    );
  }

  onImgError(event){
    event.target.src = this.defaultImage
    this.fileToUpload = null
  }

  uploadImage(event) {
    const formData: FormData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);
    return this.http.post(this.config.host + '/api/logo-partner?partnerId='+localStorage.getItem('partnerId'), formData).subscribe(
      (response) => true,
      (error: HttpErrorResponse) => {
        if(error.status === 401) {
          this.securityService.refreshToken().then(() => this.uploadImage(event))
          return true;
        } else {
          this.imageUrl = this.defaultImage
          this.fileToUpload = null
          event.target.value = null
          this.errorMessage = error.error;
          
          return false;
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts